import React, { useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import Login from './containers/Login/Login';
import SignUp from './containers/Login/SignUp';
import Pendente from './containers/Login/Pendente';
import Navbar from './components/Navbar/Navbar';
import TenantSelector from './containers/Login/TenantSelector';
import Tenants from './containers/SuperAdmin/Tenants';
import Tenant from './containers/SuperAdmin/Tenant/Tenant';
import ConfirmAddTenant from './containers/Login/ConfirmAddTenant';
import ConfirmCreateUser from './containers/Login/ConfirmCreateUser';
import ForgotPassword from './containers/Login/ForgotPassword';
import ForgotPasswordConfirmation from './containers/Login/ForgotPasswordConfirmation';
import Quicksight from './containers/SuperAdmin/Quicksight/Quicksight';
import FormEquipmentsPublic from './containers/EquipmentsPublic/FormEquipmentsPublic';
import Logs from './containers/SuperAdmin/LogsSuperadmin/LogsSuperadmin';
import EmailLogs from './containers/SuperAdmin/EmailLogsSuperadmin/EmailLogsSuperadmin';
import QRCodeReader from './containers/QRCodeReader/QRCodeReader';
import ReactGA from 'react-ga';
import { GOOGLE_ANALYTICS_TRACKING_ID } from './axios/api';


if (process.env.REACT_APP_ENV === 'prod') {
  ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
}

const Routes = () => {

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'prod') {
      ReactGA.pageview(window.location.pathname + window.location.search)
    }
  }, []);

  return (
    <Switch>
      <Route path="/login" exact component={Login} />
      <Route path="/register" exact component={SignUp} />
      <Route path="/pendente" exact component={Pendente} />
      <Route path="/tenants" exact component={Tenants} />
      <Route path="/tenant/quicksight" exact component={Quicksight} />
      <Route path="/tenant/logs" exact component={Logs} />
      <Route path="/tenant/emaillogs" exact component={EmailLogs} />
      <Route path="/tenant/:id" exact component={Tenant} />
      <Route path="/forgotpassword" exact component={ForgotPassword} />
      <Route path="/tenantselecao" exact component={TenantSelector} />
      <Route path="/forgotpasswordactivate/:id" exact component={ForgotPasswordConfirmation} />
      <Route path="/confirmaddtenant/:id" exact component={ConfirmAddTenant} />
      <Route path="/confirmcreateuser/:id" exact component={ConfirmCreateUser} />
      <Route path="/form-equip-public/:id" exact component={FormEquipmentsPublic} />
      <Route path="/qrcode" exact component={QRCodeReader} />


      <Route path="/" component={Navbar} />
    </Switch>
  );
}

export default Routes;
